import "./styles.scss"

import React, { useEffect, useState } from "react"
import { withCookies } from "react-cookie"

import { useLocale } from "context/locale"

import Button from "components/Button"

const CookieBaner = ({ cookies }) => {
  const { t } = useLocale()

  const [cookieBaner, setCookieBaner] = useState(false)

  useEffect(() => {
    const isAcceptedCoookie = !!cookies.get("cookie-accept-webinity")
    !isAcceptedCoookie && setCookieBaner(true)
  }, [cookies])

  const acceptCookieBaner = e => {
    e.preventDefault()
    const promiseSetCookie = new Promise(resolve =>
      resolve(
        cookies.set("cookie-accept-webinity", "active", {
          path: "/",
        })
      )
    )
    promiseSetCookie.then(() => {
      setCookieBaner(false)
    })
  }

  return (
    <div className={`cookie-baner${cookieBaner ? " cookie-baner--open" : ""}`}>
      <div className="cookie-baner__wrapper">
        <p>
          {t("We use cookies to improve your experience and for marketing.")}
        </p>
        <p>
          {t("Read our")}{" "}
          <a href={t("/cookies-policy/")} target="_blank" rel="noreferrer">
            {t("cookie policy")}
          </a>
          .
        </p>
        <div className="cookie-baner__cta">
          <Button
            onClick={e => acceptCookieBaner(e)}
            className="button button--small button--blue"
          >
            {t("Accept all")}
          </Button>
          <a
            href="https://www.google.com/"
            className="button button--small button--bordered-blue"
          >
            {t("Reject all")}
          </a>
        </div>
      </div>
    </div>
  )
}

export default withCookies(CookieBaner)
